import React from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";

import { TextField, Button } from "capitalrx-components";

interface DefaultProps {
  path: string;
  sectionTitle: string;
  buttonText: string;
  handleClick: Function;
}

type Props = InjectedFormProps & DefaultProps;

const PatientSummaryForm: React.FC<DefaultProps & InjectedFormProps<{}, DefaultProps>> = (props: Props) => {
  const { buttonText, sectionTitle, path, handleClick } = props;

  return (
    <div className="manual-claim-section-summary">
      <div className="row caprx-h-center-text">
        <div className="col">
          <div className="manual-claim-section-description mb30">{sectionTitle}</div>
          <Button
            handleClick={(): void => handleClick()}
            data-testid="add_patient"
            extraClasses="manual-claim-button mb30"
            buttonType="router-link"
            buttonStyle="outline"
            color="darkblue"
            path={path}
          >
            <span className="caprx-icon-input-plus mr5" />
            {buttonText}
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="external-member-id"
            data-testid="external-member-id"
            name="details.external_member_id"
            label="Patient ID"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="first-name"
            data-testid="first-name"
            name="details.first_name"
            label="First Name"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="last-name"
            data-testid="last-name"
            name="details.last_name"
            label="Last Name"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="birth-date"
            data-testid="birth-date"
            name="details.birth_date"
            label="Date of Birth"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field component={TextField} id="sex" data-testid="sex" name="details.sex" label="Gender" type="text" readOnly={true} />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="person-code"
            data-testid="person-code"
            name="details.person_code"
            label="Person Code"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="external_member_id"
            data-testid="external-member-id"
            name="details.external_member_id"
            label="Cardholder ID"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="client-id"
            data-testid="client-id"
            name="plan.client_id"
            label="Client ID"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="client-name"
            data-testid="client-name"
            name="plan.name"
            label="Client Name"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={TextField}
            id="group-id"
            data-testid="group-id"
            name="group.external_group_id"
            label="Group ID"
            type="text"
            readOnly={true}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="group-name"
            data-testid="group-name"
            name="group.group_name"
            label="Group Name"
            type="text"
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
};

export default reduxForm<{}, DefaultProps>({ form: "ManualClaim" })(PatientSummaryForm);
